<div class="custom-page-navigation" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="horizontal"></fuse-navigation>
</div>
